const ParkManagement = () => import("@/pages/park/index")
const ParkList = () => import("@/pages/park/list")
const ParkCouponList = () => import("@/pages/park/parkCoupon/list")
const ParkCouponDetails = () => import("@/pages/park/parkCoupon/send-details")
const SendParkCoupon = () => import("@/pages/park/parkCoupon/send-park-coupon")
const editorParkCoupon = () => import("@/pages/park/parkCoupon/editor-park-coupon")

export default [
    {
        path: '/park-management',
        component: ParkManagement,
        children: [
           {
                path: 'park-log-management',
                component: ParkList,
                meta: [
                    {
                        name: '停车记录',
                        url: ''
                    }
                ]
           },
           {
                path: 'park-coupon-management',
                component: ParkCouponList,
                meta: [
                    {
                       name: '停车券管理',
                       url: '',
                    }
                ]
           },
           {
                path: 'park-coupon-management/send-details',
                component: ParkCouponDetails,
                meta: [
                    {
                        name: '停车券管理',
                        url: '/park-management/park-coupon-management',
                    },
                    {
                        name: '发送记录',
                        url: ''
                    }
                ]
            },
            {
                path: 'park-coupon-management/send-park-coupon/:id',
                component: SendParkCoupon,
                meta: [
                    {
                        name: '停车券管理',
                        url: '/park-management/park-coupon-management',
                    },
                    {
                        name: '发送停车券',
                        url: ''
                    }
                ]
            },
            {
                path: 'park-coupon-management/set-park-coupon/:id',
                component: editorParkCoupon,
                meta: [
                    {
                        name: '停车券管理',
                        url: '/park-management/park-coupon-management',
                    },
                    {
                        name: '编辑停车券',
                        url: ''
                    }
                ]
            },
            {
                path: 'park-coupon-management/add-park-coupon',
                component: editorParkCoupon,
                meta: [
                    {
                        name: '停车券管理',
                        url: '/park-management/park-coupon-management',
                    },
                    {
                        name: '新增停车券',
                        url: ''
                    }
                ]
            }
        ]
    }
]


// WEBPACK FOOTER //
// ./src/router/park.js